export const clickOutside = {
  bind: function(element, binding, vnode) {
    // Получаем экземпляр Vue через vnode context
    const vm = vnode.context

    vm.$nextTick(() => {
      element.clickOutsideEvent = event => {
        if (!(element === event.target || element.contains(event.target))) {
          binding.value(event)
        }
      }
      document.addEventListener('click', element.clickOutsideEvent)
    })
  },
  unbind: function(element) {
    document.removeEventListener('click', element.clickOutsideEvent)
  }
}
